module.exports = __webpack_public_path__ + "img/navigation-icon-default.67a5e465.svg";